import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';
import { setCookie } from 'react-use-cookie';

// import { check_subdomain } from '../../../lib/server_helper';
import { fetch_one, fetch_all } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import {
  AppBar,
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Button,
  ColourPicker,
  Editor,
  FileUpload,
  ImagePicker,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { CardCoach } from '../../../components/v2/cards/Coach';
import { Confirm } from '../../../components/v2/dialogs/Confirm';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { CoachSkill } from '../../../models/CoachSkill';
import { User } from '../../../models/User';

import HelpersLanguage from '../../../actions/helpers/language';

// const { DateTime } = require("luxon");

type Props = {}

export const CoachSettingsAccount: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  const [extendedUser, setExtendedUser] = useState<User>();
  const [showAllChips, setShowAllChips] = useState<boolean>(false);
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
  const [removeOpen, setRemoveOpen] = useState<boolean>(false);
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [currentLanguageId, setCurrentLanguageId] = useState<number>(1);

  const [activeId, setActiveId] = useState<number>(login?.id || 0);
  const [bgItem, setBgItem] = useState<File>();
  const [bgItemUrl, setBgItemUrl] = useState<string>();
  const [bgItemCleared, setBgItemCleared] = useState<boolean>(false);

  const fields = [
    'id', 'first_name', 'last_name', 'auth_token', 'email', 'is_admin', 'extra_data', 'get_item_thumb', 'get_item', 'type', 'settings',
    'practice|id/name/item_is_square/get_medium', 'calendar_url', 'birth_date', 'get_bg_medium', 'profile_text', 'is_background_colour',
    'gender', 'street', 'number', 'zip', 'city', 'country_id', 'phone_mobile', 'phone_fixed', 'coach_skills', 'background_colour', 'ehealth',
    'get_medium', 'is_super', 'full_profile_text'
  ];

  const {
    data: coaches,
    isLoading: coachesLoading,
    isError: coachesError,
    isSuccess: coachesSuccess,
    refetch: coachesRefetch,
  } = useQuery({
    queryKey: ["coaches", currentPractice?.id],
    queryFn: () =>
      fetch_all<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'coach',
          fields: ['id', 'full_name'],
          filter: {
            search: '',
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id),
              is_secretary: '0',
              enabled: '1'
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });
  const {
    data: coachSkills,
    isLoading: coachSkillsLoading,
    isError: coachSkillsError,
    isSuccess: coachSkillsSuccess,
    refetch: coachSkillsRefetch,
  } = useQuery({
    queryKey: ["coach_skills", i18n.resolvedLanguage],
    queryFn: () =>
      fetch_all<CoachSkill>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'coach_skill',
          fields: ['id', 'name', 'name_en', 'name_fr', 'name_de'],
          order: 'name ASC'
        },
        login
      ),
    select: (res) => {
      let tempRes:CoachSkill[] = [];
      res.map(rrr => {
        let rrrClone = {...rrr};
        if (!!rrrClone.name_en && i18n.resolvedLanguage === 'en') rrrClone.name = rrrClone.name_en;
        if (!!rrrClone.name_fr && i18n.resolvedLanguage === 'fr') rrrClone.name = rrrClone.name_fr;
        if (!!rrrClone.name_de && i18n.resolvedLanguage === 'de') rrrClone.name = rrrClone.name_de;

        tempRes.push(rrrClone);
      });
      return tempRes
    },
    enabled: !!currentPractice?.id
  });
  const {
    data: extendedUserTemp,
    isLoading: extendedUserLoading,
    isError: extendedUserError,
    isSuccess: extendedUserSuccess,
    refetch: aextendedUserRefetch,
  } = useQuery({
    queryKey: ["settings", activeId],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          fields: fields,
          id: activeId
        },
        login
      ),
      // select: (d) => {
      //   return d.custom_result;
      // },
    enabled: !!activeId,
  });








  // const mutationCheckEmail = useMutation({
  //   mutationFn: (pars: {
  //     formData: any;
  //   }) => {
  //     return fetch_one<{exists: boolean}>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/pub/check_email`,
  //       pars.formData,
  //       undefined
  //     );
  //   },
  //   onMutate: (pars: {
  //     formData: any;
  //   }) => {
  //     // setIsCheckEmailError(false);
  //     // setCheckEmailError(undefined);
  //     return true;
  //   },
  //   onError: (data, variables, context) => {
  //     // setIsCheckEmailError(true);
  //     // setCheckEmailError(data as any);
  //     return true;
  //   },
  //   onSuccess: (data, variables, context) => {
  //     setEmailError(!!data.exists);
  //   },
  // });
  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      extra?: any;
    }) => {
      return fetch_one<{
        custom_result: {
          success: boolean,
          error?: string
        }
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      // if (!!refetch) refetch();
      setCookie('nutriportal_token', '');
      setCookie('nutriportal_email', '');
      navigate("/");
    },
  });
  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      // setIsEditPasswordError(false);
      // setEditPasswordSuccess(false);
      // setEditPasswordError(undefined);
      // setEditPasswordLoading(true);
      return true;
    },
    onError: (data, variables, context) => {
      // setIsEditPasswordError(true);
      // setEditPasswordError(data as any);
      // setEditPasswordLoading(false);
      return true;
    },
    onSuccess: (data, variables, context) => {
      aextendedUserRefetch();
      setSavedOpen(true);
      coachesRefetch();
      if (activeId === login?.id) setLogin(data);
    },
  });








  const saveUser = () => {
    if (!!extendedUser) {
      let data = new FormData();
      data.append('object', 'user');
      data.append('id', extendedUser.id?.toString() || '');
      data.append('ob[id]', extendedUser.id?.toString() || '');
      data.append('ob[first_name]', extendedUser.first_name || '');
      data.append('ob[last_name]', extendedUser.last_name || '');
      if (!!extendedUser.item) {
        data.append(`ob[item]`, extendedUser.item);
      }
      data.append('ob[is_background_colour]', !!extendedUser.is_background_colour ? '1' : '0');
      data.append('ob[background_colour]', extendedUser.background_colour || '');
      // data.append('ob[profile_text]', extendedUser.profile_text || '');
      data.append('ob[profile_text]', (extendedUser.full_profile_text || {})[1]?.toString() || '');
      (extendedUser.coach_skills || []).forEach(skill => {
        data.append('ob[coach_skill_ids][]', skill.id.toString());
      });
      if (!!bgItem) {
        data.append(`ob[background_image]`, bgItem);
      }
      if (!!bgItemUrl) {
        data.append(`ob[set_background_image_url]`, bgItemUrl);
      }
      if (!!bgItemCleared) data.append(`ob[clear_background_image]`, '1');
      Object.keys(extendedUser.full_profile_text || {}).map((key) => {
        if (parseInt(key, 10) !== 1) {
          data.append(`translations[profile_text][${key}]`, (extendedUser.full_profile_text || {})[parseInt(key, 10)]?.toString() || '');
        }
      });
      
      fields.forEach((word, index) => {
        data.append(`fields[]`, word);
      });
      // ['id', 'full_name'].forEach((word, index) => {
      //   data.append(`sub_fields[to][]`, word);
      // });
      
      mutationSave.mutate({
        formData: data
      });
    }
  }

  useEffect(() => {
    if (!!extendedUserTemp) {
      setExtendedUser(extendedUserTemp);
    }
  }, [extendedUserTemp]);
  // useEffect(() => {
  //   let to = setTimeout(() => {
  //     if (!!extendedUser && !!extendedUser.email) {
  //       mutationCheckEmail.mutate({formData: {
  //         email: extendedUser.email,
  //         skip: login?.id
  //       }});
  //     }
  //   }, 2000);

  //   return () => {
  //     clearTimeout(to);
  //   }
  // }, [!!extendedUser, extendedUser?.email]);

  return <Grid container spacing={2}>
    {!!extendedUserLoading && <Grid item xs={12} sx={{textAlign: 'center'}}>
      <CircularProgress />
    </Grid>}
    {!!extendedUser && <>
      {login?.is_super && (coaches || []).length > 1 && <Grid item xs={12}>
        {(coaches || []).map(coach => <Button
          label={coach.full_name || ''}
          id={`coach_${coach.id}`}
          onClick={() => {
            setFlickerEditor(true);
            setActiveId(coach.id || 0);
            setTimeout(() => {setFlickerEditor(false);}, 200);
          }}
          contained={activeId === coach.id}
          sx={{
            marginTop: 0,
            marginRight: 1
          }}
        />)}
      </Grid>}
      
      <Grid item xs={12} md={4} container spacing={2} sx={{alignContent: 'baseline'}}>

        {/* <Grid item xs={12}>
          <Paper sx={{
            padding: 2
          }}>
            <Box sx={{
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              display: "flex",
              flex: 1
            }}>
              <Avatar sx={{
                height: 120,
                width: 120
              }} src={extendedUser.get_item_thumb}></Avatar>
              <Typography sx={{
                marginTop: 2,
                fontSize: "1.5em"
              }}>{extendedUser.first_name} {extendedUser.last_name}</Typography>
            </Box>
          </Paper>
        </Grid> */}

        <Grid item xs={12}>
          <CardCoach
            coach={{
              ...extendedUser,
              settings: {
                ...(extendedUser.settings || {}),
                is_background_colour: extendedUser.is_background_colour,
                background_colour: extendedUser.background_colour
              }
            }}
          />
        </Grid>

      </Grid>

      <Grid container item xs={12} md={8} sx={{alignContent: 'baseline'}}>
        <Grid item xs={12}>
          <Paper sx={{
            padding: 2
          }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="h5">{t("coach.submenu.account_settings.profile")}</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  id="first_name"
                  caption={t("client.models.users.first_name", "Voornaam")}
                  placeholder={t("client.models.users.placeholders.first_name", "Vul hier je voornaam in")}
                  value={extendedUser.first_name || ''}
                  onChange={(e) => {
                    setExtendedUser({
                      ...extendedUser,
                      first_name: e
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  id="last_name"
                  caption={t("client.models.users.last_name", "Achternaam")}
                  placeholder={t("client.models.users.placeholders.last_name", "Vul hier je achternaam in")}
                  value={extendedUser.last_name || ''}
                  onChange={(e) => {
                    setExtendedUser({
                      ...extendedUser,
                      last_name: e
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <FileUpload
                  caption={t("client.models.users.item", "Afbeelding")}
                  fileInputName='item'
                  selected={extendedUser.item}
                  onChange={(f) => {
                    setExtendedUser({
                      ...extendedUser,
                      item: f as File
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{marginTop: 1}} />
                {!!mutationSave.isPending && <CircularProgress />}
                {!mutationSave.isPending && <Button
                  id="save_profile"
                  disabled={!extendedUser.first_name || !extendedUser.last_name}
                  contained
                  onClick={(e) => {
                    saveUser();
                  }}
                  label={t("client.general.buttons.submit", "Opslaan")}
                  sx={{
                    marginTop: 1
                  }}
                />}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {!login?.is_secretary && <Grid item xs={12} sx={{marginTop: 2}}>
          <Paper sx={{
            padding: 2
          }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="h5">{t("coach.submenu.account_settings.theming", "Publieke voorstelling")}</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} md={6}>
                <Switcher
                  id="is_bg_colour"
                  caption={t("coach.models.coaches.is_background_colour", "Gebruik achtergrondkleur ipv achtergrondafbeelding")}
                  value={!!extendedUser?.is_background_colour}
                  onChange={(c) => {
                    setExtendedUser({
                      ...extendedUser,
                      is_background_colour: c
                    });
                  }}
                />
              </Grid>
              {!!extendedUser?.is_background_colour && <Grid item xs={12} md={6}>
                <ColourPicker
                  label={t("coach.models.coaches.background_colour", "Achtergrondkleur")}
                  value={extendedUser?.background_colour || 'rgba(0, 0, 0, 0.4)'}
                  onChange={(v) => {
                    setExtendedUser({
                      ...extendedUser,
                      background_colour: v
                    });
                  }}
                />
              </Grid>}
              {!extendedUser?.is_background_colour && <Grid item xs={12} md={6}>
                <Typography variant="caption" sx={{display:'block'}}>{t("coach.models.coaches.background_image", "Achtergrondafbeelding")}</Typography>
                <ImagePicker
                  existing={extendedUser?.get_bg_medium}
                  deleteable
                  item={bgItem}
                  itemUrl={bgItemUrl}
                  onSelect={(_item:File|undefined, _itemUrl:string|undefined) => {
                    setBgItem(_item);
                    setBgItemUrl(_itemUrl);
                    if (!_item && !_itemUrl) {
                      setBgItemCleared(true);
                    } else {
                      setBgItemCleared(false);
                    }
                  }}
                />
              </Grid>}
              <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
                <AppBar position="static" sx={{backgroundColor: theme.palette.primary.contrastText}}>
                  <Tabs value={currentLanguageId} onChange={(ev, i) => {
                    setCurrentLanguageId(i);
                    setFlickerEditor(true);
                    setTimeout(() => {setFlickerEditor(false);}, 200);
                  }}>
                    {HelpersLanguage.available_locales().map((locale, i) => {
                      return (<Tab value={HelpersLanguage.mapping_to_id(locale)} label={locale.toUpperCase()} id={`locale_tab_${locale}`} />)
                    })}
                  </Tabs>
                </AppBar>
              </Grid>
              <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
                <Typography variant="caption" sx={{display:'block'}}>{t("coach.models.coaches.profile_text", "Korte profieltekst voor 'Mijn Praktijk'")}:</Typography>
                {!flickerEditor && <Editor
                  advanced
                  label=""
                  value={(extendedUser?.full_profile_text || {})[currentLanguageId] || ""}
                  onChange={(e) => {
                    setExtendedUser({
                      ...extendedUser,
                      full_profile_text: {
                        ...(extendedUser.full_profile_text || {}),
                        [currentLanguageId]: e
                      }
                    });
                  }}
                />}
              </Grid>
              {!extendedUser.is_secretary && <Grid item xs={12}>
                <Typography variant="caption" sx={{display:'block'}}>{t("coach.submenu.account_settings.skills")}:</Typography>
                {!showAllChips && (coachSkills || []).sort((a, b) => (extendedUser.coach_skills.filter(fff => fff.id === b.id).length - extendedUser.coach_skills.filter(fff => fff.id === a.id).length) || a.name.localeCompare(b.name)).slice(0, extendedUser.coach_skills.length > 6 ? extendedUser.coach_skills.length : 6).map(skill => <Chip
                  sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
                  label={skill.name}
                  onClick={(e) => {
                    if (extendedUser.coach_skills.filter(fff => fff.id === skill.id).length > 0) {
                      setExtendedUser({
                        ...extendedUser,
                        coach_skills: extendedUser.coach_skills.filter(fff => fff.id !== skill.id)
                      });
                    } else {
                      setExtendedUser({
                        ...extendedUser,
                        coach_skills: [...extendedUser.coach_skills, skill]
                      });
                    }
                  }}
                  variant="outlined"
                  icon={extendedUser.coach_skills.filter(fff => fff.id === skill.id).length > 0 ? <DoneIcon /> : <AddIcon />}
                  color={extendedUser.coach_skills.filter(fff => fff.id === skill.id).length > 0 ? "primary" : 'default'}
                />)}
                {!showAllChips && <Chip
                  sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
                  label={t("shared.chips.show_more")}
                  onClick={(e) => {
                    setShowAllChips(true);
                  }}
                  variant="outlined"
                  icon={<Visibility />}
                  color="primary"
                />}
                {!!showAllChips && (coachSkills || []).sort((a, b) => (extendedUser.coach_skills.filter(fff => fff.id === b.id).length - extendedUser.coach_skills.filter(fff => fff.id === a.id).length) || a.name.localeCompare(b.name)).map(skill => <Chip
                  sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
                  label={skill.name}
                  onClick={(e) => {
                    if (extendedUser.coach_skills.filter(fff => fff.id === skill.id).length > 0) {
                      setExtendedUser({
                        ...extendedUser,
                        coach_skills: extendedUser.coach_skills.filter(fff => fff.id !== skill.id)
                      });
                    } else {
                      setExtendedUser({
                        ...extendedUser,
                        coach_skills: [...extendedUser.coach_skills, skill]
                      });
                    }
                  }}
                  variant="outlined"
                  icon={extendedUser.coach_skills.filter(fff => fff.id === skill.id).length > 0 ? <DoneIcon /> : <AddIcon />}
                  color={extendedUser.coach_skills.filter(fff => fff.id === skill.id).length > 0 ? "primary" : 'default'}
                />)}
                {!!showAllChips && <Chip
                  sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
                  label={t("shared.chips.show_less")}
                  onClick={(e) => {
                    setShowAllChips(false);
                  }}
                  variant="outlined"
                  icon={<VisibilityOff />}
                  color="primary"
                />}
              </Grid>}

              <Grid item xs={12}>
                <Divider sx={{marginTop: 1}} />
                {!!mutationSave.isPending && <CircularProgress />}
                {!mutationSave.isPending && <Button
                  id="save_profile"
                  disabled={!extendedUser.first_name || !extendedUser.last_name}
                  contained
                  onClick={(e) => {
                    saveUser();
                  }}
                  label={t("client.general.buttons.submit", "Opslaan")}
                  sx={{
                    marginTop: 1
                  }}
                />}
              </Grid>
            </Grid>
          </Paper>
        </Grid>}
      </Grid>
    </>}

    <Confirm
      open={confirmOpen}
      setOpen={setConfirmOpen}
      title={t("coach.submenu.detail.password_reset")}
      content={t("general.confirm.password_reset", "Bent u zeker dat u dit item wil verwijderen?")}
      execute={() => {
        mutationCustomAction.mutate({formData: {
          object: 'user',
          class_action: 'custom_api_forgot_pass',
          id: login?.id
        }});
      }}
    />

    <Confirm
      open={removeOpen}
      setOpen={setRemoveOpen}
      title={t("client.general.buttons.close_account")}
      content={t("general.confirm.close_account", "Bent u zeker dat u dit item wil verwijderen?")}
      execute={() => {
        mutationCustomAction.mutate({formData: {
          object: 'user',
          class_action: 'custom_api_close_acount',
          id: login?.id
        }});
      }}
    />

    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Grid>;
}

